import BoardList from "../../templates/BoardList";

const HalfTime = () => {
  return <BoardList boardCategory="half-time" />;
};

export default HalfTime;
